module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "ch03"
    }
  }, [_c('a', {
    attrs: {
      "id": "page3"
    }
  }, [_c('div', {
    staticClass: "chapterHead"
  }, [_c('h2', {
    staticClass: "chapterTitle"
  })]), _vm._v(" "), _c('div', {
    staticClass: "chapterBody"
  }, [_c('p', {
    staticClass: "chapterOpenerText"
  }, [_c('span', {
    staticClass: "chapterOpenerFirstWords"
  }, [_c('span', {
    staticClass: "bold"
  }, [_vm._v("It never fails to amaze me.")])])]), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("Create a paradise out of the ether. Throw in some wildlife, volcanoes, and windstorms. Some iguanas, koalas, and waterfalls. Come back a few billion years later, and just when it looks like the whole place is going to implode—with pollution, disease, and war; famine, fatigue, and fright—there are still those who see the beauty. Who act with kindness. And who live with hope and gratitude.")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_vm._v("Actually, they carry the entire planet. Who’d have thunk?")]), _vm._v(" "), _c('p', {
    staticClass: "spaceBreak"
  }), _vm._v(" "), _c('p', {
    staticClass: "paraCenter"
  }, [_c('em', {
    staticClass: "italic"
  }, [_vm._v("Yeah, okay. Guilty.")])])])])]), _c('a', {
    attrs: {
      "id": "page3"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-6c8de360","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/9781416594161_ch03.vue
// module id = 96
// module chunks = 0